import React, { useState, useEffect } from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import LoaderContainer from "../../components/LoaderContainer";
import axios from "axios";
import { SERVER_BASE_ADDRESS } from "../../globals/const";
import ASQILogo from "../../assets/logo/ASQI-logo.png";
import ASQILogoBlue from "../../assets/logo/ASQI-logo-B4.png";

// Component for the invoice header
const InvoiceHeader = ({ invoiceData }) => (
  <>
    <Box sx={{ ml: "-50px" }}>
      <img
        src={ASQILogo}
        alt="ASQI Logo"
        style={{
          height: "120px",
          opacity: 0.9,
        }}
      />
    </Box>

    <Box>
      <Typography align="center" sx={{ fontWeight: "bold", color: "#000" }}>
        Tax Invoice
      </Typography>
      <Typography align="center" sx={{ fontWeight: "bold", color: "#000" }}>
        Original for Recipient
      </Typography>
    </Box>

    <Grid container mt={2} spacing={2} sx={{ mb: 4 }}>
      <Grid item xs={6}>
        <Typography>Invoice No: {invoiceData?.invoice_number}</Typography>
      </Grid>
      <Grid item xs={6} sx={{ textAlign: "right" }}>
        <Typography>
          Date:{" "}
          {invoiceData?.created_at
            ? new Date(invoiceData.created_at).toLocaleDateString("en-GB", {
                day: "numeric",
                month: "long",
                year: "numeric",
              })
            : ""}
        </Typography>
      </Grid>
    </Grid>

    <Grid container mt={2} sx={{ mb: 4 }}>
      <Grid item xs={12}>
        <Typography>{invoiceData?.name}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography>{invoiceData?.address}</Typography>
      </Grid>
    </Grid>
  </>
);

// Component for the invoice table
const InvoiceTable = ({ invoiceData }) => (
  <Box sx={{ mb: 4 }}>
    <Paper elevation={0}>
      <Grid
        container
        sx={{
          borderBottom: "2px solid #000",
          borderTop: "2px solid #000",
          px: 1,
          py: 0,
        }}
      >
        <Grid item xs={8} sx={{ fontWeight: "bold" }}>
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            Particulars
          </Typography>
        </Grid>
        <Grid item xs={4} sx={{ textAlign: "right" }}>
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            Amount (in INR)
          </Typography>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={8} sx={{ p: 1 }}>
          <Typography>
            {invoiceData?.description || "Farmapp subscription"}
          </Typography>
        </Grid>
        <Grid item xs={4} sx={{ p: 1, textAlign: "right" }}>
          <Typography>{(invoiceData?.amount || 0).toFixed(2)}</Typography>
        </Grid>
      </Grid>

      <Grid
        container
        mt={3}
        sx={{
          borderTop: "2px solid #000",
        }}
      >
        <Grid item xs={8} sx={{ px: 1, py: 0, textAlign: "center" }}>
          <Typography>Amount</Typography>
        </Grid>
        <Grid item xs={4} sx={{ px: 1, py: 0, textAlign: "right" }}>
          <Typography sx={{ fontWeight: "bold" }}>
            {(invoiceData?.amount || 0).toFixed(2)}
          </Typography>
        </Grid>
      </Grid>

      <Grid
        container
        sx={{
          borderBottom: "2px solid #000",
        }}
      >
        <Grid item xs={8} sx={{ textAlign: "center", px: 1, py: 0 }}>
          <Typography>GST</Typography>
        </Grid>
        <Grid item xs={4} sx={{ px: 1, py: 0, textAlign: "right" }}>
          <Typography>{(invoiceData?.gst_amount || 0).toFixed(2)}</Typography>
        </Grid>
      </Grid>

      <Grid
        container
        sx={{
          borderBottom: "2px solid #000",
        }}
      >
        <Grid item xs={8} sx={{ py: 0, px: 1, fontWeight: "bold" }}>
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            Gross Amount
          </Typography>
        </Grid>
        <Grid item xs={4} sx={{ py: 0, px: 1, textAlign: "right" }}>
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            {(
              (invoiceData?.amount || 0) + (invoiceData?.gst_amount || 0)
            ).toFixed(2)}
          </Typography>
        </Grid>
      </Grid>
    </Paper>

    {/* <Box sx={{ mt: 2, mb: 4, py: 0, px: 1 }}>
      <Typography variant="body1" sx={{ fontWeight: "bold" }}>
        Amount in words : {invoiceData?.amount_in_words}
      </Typography>
    </Box> */}
  </Box>
);

// Component for the invoice footer info
const InvoiceFooterInfo = () => (
  <>
    <Box sx={{ mt: 6, textAlign: "right" }}>
      <Box
        sx={{
          borderTop: "2px solid #000",
          display: "inline-block",
          width: "200px",
        }}
      >
        <Typography sx={{ mt: 1, textAlign: "center", fontWeight: "bold" }}>
          Authorised Signatory
        </Typography>
      </Box>
    </Box>

    <Box
      sx={{
        mt: 4,
        borderTop: "2px solid #000",
        borderBottom: "2px solid #000",
        py: 0,
        px: 1,
      }}
    >
      <Typography>PAN NO : AAECE2320A</Typography>
      <Typography>GST Registration No. : 27AAECE2320A1ZF</Typography>
    </Box>

    <Grid container mt={2} sx={{ py: 0, px: 1 }}>
      <Grid item xs={12}>
        <Typography sx={{ fontWeight: "bold", fontSize: 14 }}>
          Terms & Conditions :
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography fontSize={14}>
          a) This Bill is payable on receipt by Wire transfer in favour of ASQI
          Investment Managers Private Limited
        </Typography>
        <Typography fontSize={14}>
          b) Please make payment immediately on the receipt of this invoice.
        </Typography>
        <Typography fontSize={14}>
          c) In case of any queries regarding the Invoice, please contact us on
          +91-22-61810000
        </Typography>
      </Grid>
    </Grid>

    <Grid container mt={2} sx={{ mb: 4, py: 0, px: 1 }}>
      <Grid item xs={12}>
        <Typography sx={{ fontWeight: "bold", fontSize: 14 }}>
          Bank Details :
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography fontSize={14}>Bank Name : ICICI Bank Ltd</Typography>
        <Typography fontSize={14}>Address : Chembur Branch</Typography>
        <Typography fontSize={14}>Account No : 742305000075</Typography>
        <Typography fontSize={14}>Swift Code: ICICINBBNRI</Typography>
        <Typography fontSize={14}>RTGS / NEFT IFSC : ICIC0006239</Typography>
      </Grid>
    </Grid>
  </>
);

// Component for the page footer
const PageFooter = () => (
  <Paper
    elevation={0}
    sx={{
      position: "relative",
      padding: "0 5px",
    }}
  >
    <Grid container spacing={0.5}>
      <Grid item xs={3}>
        <Box sx={{ bgcolor: "#5b8dc0", height: "30px" }}></Box>
      </Grid>
      <Grid item xs={6}>
        <Box sx={{ bgcolor: "#2c4b73", height: "30px" }}></Box>
      </Grid>
      <Grid item xs={3}>
        <Box sx={{ bgcolor: "#5b8dc0", height: "30px" }}></Box>
      </Grid>
    </Grid>

    <Grid
      container
      spacing={0}
      sx={{ borderBottom: "4px solid #757070", py: 0 }}
    >
      <Grid item xs={3} sx={{ textAlign: "center" }}>
        <Typography fontSize={10}>WWW.ASQI.IN</Typography>
      </Grid>
      <Grid item xs={6} sx={{ textAlign: "center" }}>
        <Typography fontSize={10}>CONNECT@ASQI.IN</Typography>
      </Grid>
      <Grid item xs={3} sx={{ textAlign: "center" }}>
        <Typography fontSize={10}>+91 98208 93430</Typography>
      </Grid>
    </Grid>

    <Grid container spacing={0} sx={{ py: 1 }}>
      <Grid item xs={3} sx={{ textAlign: "center" }}>
        <Typography fontSize={10}>CIN NO - U62099MH2016FTC274805</Typography>
      </Grid>
      <Grid item xs={9} sx={{ textAlign: "center" }}>
        <Typography fontSize={10}>
          H 532, KANAKIA ZILLION, BKC ANNEXE, KURLA (WEST), MUMBAI 400 070.
        </Typography>
      </Grid>
    </Grid>
  </Paper>
);

// Main component
const InvoicePublicPage = () => {
  const { invoiceUUID } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [invoiceData, setInvoiceData] = useState(null);

  useEffect(() => {
    if (!invoiceUUID) return;
    fetchInvoiceData(invoiceUUID);
  }, [invoiceUUID]);

  const fetchInvoiceData = async (invoiceUUID) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${SERVER_BASE_ADDRESS}/payments/get-invoice-details-public/${invoiceUUID}/`
      );
      setInvoiceData(response.data);
      setError(null);
    } catch (err) {
      console.error("Error fetching invoice data:", err);
      setError("Failed to fetch invoice details");
    } finally {
      setLoading(false);
    }
  };

  // Watermark component
  const Watermark = () => (
    <Box
      sx={{
        position: "absolute",
        top: "52%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        opacity: 0.1,
        zIndex: 0,
        width: "80%",
        height: "90%",
        backgroundImage: `url(${ASQILogoBlue})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "contain",
        color: "black",
      }}
    />
  );

  // Render invoice content
  const renderInvoiceContent = () => {
    if (error) {
      return <Typography color="error">{error}</Typography>;
    }

    if (!invoiceData) {
      return null;
    }

    return (
      <>
        <Paper
          sx={{
            padding: "0 15mm",
            elevation: 0,
            position: "relative",
            borderRadius: 0,
            boxShadow: "none",
          }}
        >
          <Watermark />
          <InvoiceHeader invoiceData={invoiceData} />
          <InvoiceTable invoiceData={invoiceData} />
          <InvoiceFooterInfo invoiceData={invoiceData} />
        </Paper>
        <PageFooter />
      </>
    );
  };

  return (
    <Box
      sx={{ maxWidth: 800, margin: "auto", backgroundColor: "#ffffff", mt: 1 }}
    >
      <LoaderContainer loading={loading}>
        {renderInvoiceContent()}
      </LoaderContainer>
    </Box>
  );
};

export default InvoicePublicPage;
